<template>
  <div>
    <exposure-drilldown
      :reportParameters="lastParams"
      :is-read-only="isReadOnly"
      :value="drilldownOpen"
      @input="drilldownOpen = $event"
    />
    <page-toolbar>
      <exposure-toolbar
        @change="onChange"
        @export="onExport"
        showQuarter
        :show-option-drop-down="true"
        v-slot="slotProps"
        :marketId="marketId"
      >
        <kendo-button
          type="button"
          @click="onExport(slotProps.toolbar.getSelectedValues())"
          icon="excel"
          title="Export to Excel"
        />
        <kendo-button
          type="button"
          @click="showChart(slotProps.toolbar.getSelectedValues())"
          title="Open Chart"
          style="display:inline-block"
        >
          <v-icon small>bar_chart</v-icon>
        </kendo-button>
        <kendo-button
          type="button"
          @click="drillDown(slotProps.toolbar.getSelectedValues())"
          title="Transaction open for delivery"
          v-show="getCcyPairIsFx"
        >
          <v-icon small>view_list</v-icon>
        </kendo-button>
      </exposure-toolbar>
    </page-toolbar>

    <div ref="container" class="exposureGrid"></div>

    <simple-dialog
      v-model="chartDialog"
      :isDialog="false"
      :width="830"
      :height="420"
      title="Exposure chart"
    >
      <div class="chart" ref="marketDataChart" />
      <v-progress-linear :indeterminate="true" v-if="chartLoading"></v-progress-linear>
    </simple-dialog>
  </div>
</template>

<script>
import PageToolbar from '@/components/PageToolbar'
import ExposureToolbar from '@/components/Report/ExposureToolbarV4'
import ExposureDrilldown from '@/components/Report/ExposureDrilldown'
import exposureGrid from '@/dashboard-components/exposure-gridV4'
import exposureChart from '@/dashboard-components/exposure-chart'
import params from '@/helpers/params'
import {getDataItem} from '@/helpers/kendo-helpers'
import {mapGetters} from 'vuex'
import security from '@/mixins/security'
import SimpleDialog from '@/components/SimpleDialog'

export default {
  name: 'ExposureV4',
  mixins: [security],
  data() {
    return {chartDialog: false, chartLoading: false, lastParams: null, drilldownOpen: false}
  },
  mounted() {
    this.$el.addEventListener('click', this.drilldownClick, false)
  },
  methods: {
    drilldownClick({target}) {
      if (!/adjustmentDrillDown|hedge\w+DrillDown/.test(target.className)) return

      const dataItem = getDataItem(target)

      const startDate = kendo.toString(dataItem.PeriodStart, 's')
      const endDate = kendo.toString(dataItem.PeriodEnd, 's')
      const {className} = target
      const columnType = className.includes('adjustmentDrillDown')
        ? 3
        : className.includes('hedgeCDrillDown')
        ? 1
        : 2

      const drilldownParams = {startDate, endDate, columnType}
      this.lastParams = {...this.lastParams, ...drilldownParams}
      this.drilldownOpen = true
    },
    drillDown(e) {
      const columnType = 4
      const startDate = e.asOfDate
      const endDate = e.toDate
      const drilldownParams = {startDate, endDate, columnType}
      this.lastParams = {...this.lastParams, ...drilldownParams}
      this.drilldownOpen = true
    },
    onChange(e) {
      exposureGrid.render(kendo.jQuery(this.$refs.container), e, 'report')
      this.lastParams = e
    },
    onExport(e) {
      const qs = params.fromObject({
        t: this.tokenString,
        ...e,
      })
      location.href = `/api/report/ExposureReportV4/Export?${qs}`
    },
    async showChart(params) {
      kendo.destroy(this.$refs.marketDataChart)
      kendo.jQuery(this.$refs.marketDataChart).empty()
      this.chartDialog = true
      this.chartLoading = true
      await exposureChart.render(this.$refs.marketDataChart, params, 'report').catch(() => {
        this.chartLoading = false
      })
      this.chartLoading = false
    },
  },
  computed: {
    ...mapGetters({tokenString: 'authentication/tokenString'}),
    ...mapGetters({marketId: 'app/marketId'}),
    getCcyPairIsFx() {
      return this.lastParams != null && this.lastParams.foreignCcyIsFx
    },
  },
  beforeDestroy() {
    kendo.destroy(this.$refs.container)
    kendo.destroy(this.$refs.marketDataChart)
    this.$el.removeEventListener('click', this.drilldownClick)
  },
  components: {
    PageToolbar,
    ExposureToolbar,
    ExposureDrilldown,
    SimpleDialog,
  },
}
</script>

<style scoped>
.exposureGrid {
  font-size: 0.9em;
}
.chart {
  overflow: hidden;
}
</style>
<style>
.hedgeCDrillDown,
.hedgeNCDrillDown,
.adjustmentDrillDown {
  text-decoration: underline;
}

.hedgeCDrillDown:hover,
.hedgeNCDrillDown:hover,
.adjustmentDrillDown:hover {
  cursor: pointer;
}
</style>
